export const BUDGET_PLAN_SCOPE = Object.freeze({
  DEPARTMENT: "department",
  PROJECT: "project",
});

export const BUDGET_PLAN_SCOPE_LABELS = {
  department: "Team allocation",
  project: "Single project",
};

export function normalizeBudgetPlanScope(raw) {
  const s = String(raw || "").trim().toLowerCase();
  return s === BUDGET_PLAN_SCOPE.PROJECT ? BUDGET_PLAN_SCOPE.PROJECT : BUDGET_PLAN_SCOPE.DEPARTMENT;
}
